// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"Mu-z","tooltipWrapper":"Nu-z","icon":"Ou-z","tooltip":"Pu-z","content":"Qu-z"};